export default __webpack_public_path__ + "static/media/dm_carousel_1.png.webp";